// TradingViewGoldChart.jsx
import React, { useEffect, useRef, memo } from "react";

function TradingViewGoldChart() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    containerRef.current.innerHTML = "";

    const script = document.createElement("script");
    script.src =
  "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";

    script.async = true;

    script.innerHTML = `
{
  "symbol": "FX_IDC:XAUUSD",
  "interval": "60",
  "timezone": "Etc/UTC",
  "theme": "light",
  "style": "1",
  "locale": "en",
  "enable_publishing": false,
  "allow_symbol_change": false,
  "calendar": false,
  "studies": [
    "MASimple@tv-basicstudies",
    "RSI@tv-basicstudies"
  ],
  "container_id": "tradingview_gold"
}
`;


    containerRef.current.appendChild(script);
  }, []);

 return (
  <div
    id="tradingview_gold"
    ref={containerRef}
    style={{ width: "100%", height: "400px" }}
  />
);

}

export default memo(TradingViewGoldChart);
